const TOOL_SCHEMA_METHODS = [
  'getInputSchema',
  'getSchema',
  'getInputZodSchema',
  'getZodSchema',
  'inputSchema',
  'schema',
  'getRawData',
];

const POSSIBLE_SCHEMA_PATHS = [
  'parameterSchema',
  'inputSchema',
  'schema',
  '_inputSchema',
  '_schema',
  'inputZodSchema',
  'zodSchema',
  '_inputZodSchema',
  '_zodSchema',
  '_marketplaceOffer.inputSchema',
  '_marketplaceOffer.schema',
  '_marketplaceOffer.inputZodSchema',
  '_marketplaceOffer.zodSchema',
];

function resolveSchemaFromData(data: any): any | undefined {
  if (!data) return undefined;

  for (const path of POSSIBLE_SCHEMA_PATHS) {
    const schemaValue = path
      .split('.')
      .reduce((current: any, key) => current?.[key], data);
    if (schemaValue) return schemaValue;
  }

  return undefined;
}

/**
 * Resolve a tool-style object's input schema by probing the same set of
 * methods / property paths used across workflow editors.
 *
 * Returning `undefined` means "no schema available" — JSON validation still
 * runs, but Zod validation is skipped.
 */
export function resolveToolInputSchema(toolObject: any): any | undefined {
  if (!toolObject) return undefined;

  for (const methodName of TOOL_SCHEMA_METHODS) {
    if (typeof toolObject[methodName] !== 'function') continue;

    try {
      const result = toolObject[methodName]();

      if (methodName === 'getRawData') {
        const schemaFromRawData = resolveSchemaFromData(result);
        if (schemaFromRawData) return schemaFromRawData;
      } else if (result && typeof result === 'string') {
        return result;
      }
    } catch {
      // Silently handle errors (matches proprietary editor behavior).
    }
  }

  return resolveSchemaFromData(toolObject.rawData);
}
